document.addEventListener('alpine:init', () => {
  Alpine.store('wishlist', {
    products: [],
    detailedList: [],
    movingToCart: [],
    scrollPos: 0,
    hasReachedEnd: false,
    needsScroll: false,
    userLoggedIn: false,
    init () {
      this.getWishlist()
    },
    async getDetailedWishlist () {
      const response = await fetch('/api/wishlist?detailedList=true', {
        credentials: 'include'
      })
      const json = await response.json()
      this.detailedList = json.detailedList
    },
    async getWishlist () {
      const response = await fetch('/api/wishlist', {
        credentials: 'include'
      })
      const json = await response.json()
      this.products = json.list
    },
    isInStore (variant_id, id) {
      return this.products.find(el => el === `${id}:${variant_id}`)
    },
    isMovingToCart (id) {
      return this.movingToCart.find(el => el === id)
    },
    moveToCart (data, getDetailedList) {
      this.movingToCart.push(data.variant_id)
      Alpine.store('main').addToCart([{ variant_id: data.variant_id, quantity: 1 }], true)
      setTimeout(() => {
        const index = this.movingToCart.findIndex(el => el === data.variant_id)
        this.movingToCart.splice(index, 1)
        this.toggleAddRemove(data, getDetailedList)
      }, 1020);
    },
    async toggleAddRemove (data, getDetailedList) {
      const index = this.products.findIndex(el => el === `${data.id}:${data.variant_id}`)
      if (index === -1) {
        const response = await fetch(`/api/wishlist${getDetailedList ? '?getDetailedList=true' : ''}`, {
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({
            variant_id: data.variant_id,
            id: data.id
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        })
        const json = await response.json()
        this.products = json.list
        if (getDetailedList) {
          this.detailedList = json.detailedList
        }
        
        dataLayer.push({
          event: "add_to_wishlist",
          ecommerce: {
            items: [{
              id: window.selectProductId({ id: data.variant_id, sku: data.sku }, voleroAnalyticsProductIdType),
              item_id: window.selectProductId({ id: data.variant_id, sku: data.sku }, voleroAnalyticsProductIdType),
              item_name: data.title,
              currency: 'EUR',
              quantity: 1,
              price: data.price,
              item_variant: data.variant_id,
            }]
          }
        });
       
        window.sqzlPushWrapper({
          "event": "add_to_wishlist",
          "products": [{
            id: data.sku,
            item_id: data.sku,
            name: data.title,
            currency: 'EUR',
            quantity: 1,
            price: data.price,
            item_variant: data.variant_id,
          }]
        });
      }
      else {
        const response = await fetch(`/api/wishlist/${data.id}:${data.variant_id}${getDetailedList ? '?getDetailedList=true' : ''}`, {
          method: 'DELETE',
          credentials: 'include'
        })

        const json = await response.json()
        this.products = json.list
        if (getDetailedList) {
          this.detailedList = json.detailedList
        }

        window.sqzlPushWrapper({
          "event": "remove_from_wishlist",
          "products": [{
            id: data.sku,
            item_id: data.sku,
            item_name: data.title,
            currency: 'EUR',
            quantity: 1,
            price: data.price,
            item_variant: data.variant_id,
          }]
        });

        dataLayer.push({
          event: "remove_from_wishlist",
          ecommerce: {
            items: [{
              id: window.selectProductId({ id: data.variant_id, sku: data.sku }, voleroAnalyticsProductIdType),
              item_id: window.selectProductId({ id: data.variant_id, sku: data.sku }, voleroAnalyticsProductIdType),
              item_name: data.title,
              currency: 'EUR',
              quantity: 1,
              price: data.price,
              item_variant: data.variant_id,
            }]
          }
        });
      }
    }
  })
})

